/* STAHL: aclara talla/envío y evita enviar una variante mientras cambia. */
(() => {
  if (window.__stahlPdpClaridad) return;
  window.__stahlPdpClaridad = true;
  const states = new WeakMap();
  const rootSelector = '.section-main-product';
  const text = (node, value) => { if (node.textContent !== value) node.textContent = value; };

  function current(root) {
    const picker = root.querySelector('variant-picker');
    const form = picker?.closest('product-form')?.querySelector('form.js-product-form');
    if (!picker || !form) return null;
    let variant = null;
    try { variant = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || 'null'); } catch (_) {}
    const options = [...picker.querySelectorAll('.option-selector:not(.option-selector--custom)')].map(group => {
      const selected = group.querySelector('input:checked, .js-option[aria-selected="true"]');
      return selected ? (selected.dataset.value ?? selected.value ?? null) : null;
    });
    const id = form.querySelector('[name="id"]')?.value;
    const matches = Boolean(variant && id === String(variant.id) && options.length === variant.options?.length && options.every((v, i) => v !== null && v === variant.options[i]));
    return { picker, form, variant, options, matches };
  }

  function message(root) {
    let node = root.querySelector('[data-stahl-variant-status]');
    const data = current(root);
    if (!node && data) {
      node = document.createElement('p');
      node.className = 'stahl-pdp-status';
      node.dataset.stahlVariantStatus = '';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.hidden = true;
      data.form.before(node);
    }
    return node;
  }

  function setBusy(root, busy) {
    const state = states.get(root);
    if (!state) return;
    state.busy = busy;
    root.toggleAttribute('data-stahl-variant-pending', busy);
    const data = current(root);
    if (!data) return;
    const forms = [data.form, ...root.querySelectorAll('sticky-atc form.js-product-form')];
    forms.forEach(form => {
      form.toggleAttribute('aria-busy', busy);
      form.querySelectorAll('[name="add"]').forEach(button => {
        if (busy) {
          if (!state.buttons.has(button)) state.buttons.set(button, button.disabled);
          button.disabled = true;
        } else if (state.buttons.has(button)) {
          button.disabled = state.buttons.get(button) || !data.variant?.available;
          state.buttons.delete(button);
        }
      });
    });
    root.querySelectorAll('.product-dynamic-payment-button').forEach(wallet => {
      wallet.inert = busy || !data.variant?.available;
    });
    if (!busy && typeof data.picker.updateAddToCartButton === 'function') data.picker.updateAddToCartButton();
  }

  function addNotes(root) {
  const data = current(root);
  if (!data) return;

  const size = [...data.picker.querySelectorAll('.option-selector')]
    .find(el => /^(talla|size)$/i.test(el.dataset.option || ''));

  if (size && !size.querySelector('[data-stahl-size-note]')) {
    const note = document.createElement('div');
    note.className = 'stahl-pdp-note stahl-pdp-note--size';
    note.dataset.stahlSizeNote = '';
    note.innerHTML = '<p>Horma amplia. Elige tu talla habitual; si usas medio número, sube al siguiente.</p>';

    const buttons = size.querySelector('.option-selector__btns');
    buttons ? buttons.after(note) : size.append(note);
  }

  const row = data.form.querySelector('.quantity-submit-row');

  if (row && !data.form.querySelector('[data-stahl-shipping-note]')) {
    const note = document.createElement('div');
    note.className = 'stahl-pdp-note stahl-pdp-note--shipping';
    note.dataset.stahlShippingNote = '';
    note.innerHTML = `
      <p><strong>Envío estándar $150 · Gratis desde $1,299</strong></p>
      <p>
        3–5 días hábiles desde el despacho.
        <a href="/policies/shipping-policy">Ver plazos y envío exprés</a>
      </p>
    `;

    row.after(note);
  }

  if (root.querySelector('[data-stahl-shipping-note]')) {
    root.querySelectorAll('.stahl-pdp-trust__item').forEach(item => {
      if (/env[ií]o.*gratis/i.test(item.textContent)) {
        item.hidden = true;
      }
    });
  }

  message(root);
}

  function begin(root) {
    const state = states.get(root);
    if (!state) return;
    clearTimeout(state.timeout);
    setBusy(root, true);
    const status = message(root);
    if (status) { text(status, 'Actualizando tu selección…'); status.hidden = false; }
    state.timeout = setTimeout(() => {
      if (!root.isConnected || !state.busy) return;
      const node = message(root);
      if (node) { text(node, 'No pudimos confirmar la selección. Vuelve a elegir color y talla antes de añadir al carrito.'); node.hidden = false; }
    }, 12000);
  }

  function finish(root) {
    const state = states.get(root), data = current(root);
    if (!state || !data) return;
    const unavailable = !data.variant && !data.form.querySelector('[name="id"]')?.value && data.options.every(value => value !== null);
    if (!data.matches && !unavailable) return;
    clearTimeout(state.timeout);
    setBusy(root, false);
    const status = message(root);
    if (status) {
      text(status, data.variant?.available ? 'Tu selección: ' + data.options.join(' / ') : 'Esta combinación no está disponible. Elige otro color o talla.');
      status.hidden = false;
    }
  }

  function mount(root) {
    if (!states.has(root)) {
      const state = { busy: false, buttons: new WeakMap(), timeout: null, queued: false };
      states.set(root, state);
      const observer = new MutationObserver(() => {
        if (state.queued) return;
        state.queued = true;

                requestAnimationFrame(() => {
          state.queued = false;

          if (!root.isConnected) {
            clearTimeout(state.timeout);
            observer.disconnect();
            return;
          }

          addNotes(root);

          if (state.busy) {
            setBusy(root, true);
          }
        });
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });
    }

    addNotes(root);
  }

  function init(scope = document) {
    if (scope.matches?.(rootSelector)) {
      mount(scope);
    }

    scope.querySelectorAll(rootSelector).forEach(mount);
  }

  document.addEventListener('change', event => {
    const picker = event.target.closest?.('variant-picker');
    const root = picker?.closest(rootSelector);

    if (!root || !event.target.closest('.option-selector')) {
      return;
    }

    mount(root);
    begin(root);
  }, true);

  document.addEventListener('on:variant:change', event => {
    const root = event.target.closest?.(rootSelector);

    if (!root) return;

    mount(root);
    finish(root);
  });

  document.addEventListener('submit', event => {
    const form = event.target;

    if (!form.matches?.('form.js-product-form')) return;

    const root = form.closest(rootSelector);

    if (!root) return;

    const data = current(root);

    if (!data) return;

    if (form !== data.form && !form.closest('sticky-atc')) {
      return;
    }

    const submittedId = form.querySelector('[name="id"]')?.value;

    const valid =
      !states.get(root)?.busy &&
      data.matches &&
      data.variant?.available &&
      submittedId === String(data.variant.id);

    if (valid) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    mount(root);
    begin(root);

    const status = message(root);

    if (status) {
      text(
        status,
        'Confirma tu color y talla. Estamos actualizando la selección antes de añadirla.'
      );
    }

    if (
      data.matches &&
      submittedId === String(data.variant.id)
    ) {
      finish(root);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(),
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    event => init(event.target)
  );
})();